const logger = (_store: any) => (next: any) => (action: any) => {
	if (Boolean(action?.payload) && action.payload.message === 'User not found') {
		localStorage.clear();
		window.location.href = '/';
	}
	const result = next(action);
	return result;
};

export default logger;
